export default __webpack_public_path__ + "static/media/us_1.636640eb.mp3";